import { createReducer } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { getPolygonPreview } from '../../redux';
const initialState = {
    polygonPreview: null,
    error: null,
    isLoading: false,
};
const polygonPreview = createReducer(initialState, (builder) => {
    builder
        .addCase(getPolygonPreview.request, (state) => {
        state.isLoading = true;
        state.error = null;
    })
        .addCase(getPolygonPreview.success, (state, action) => {
        const { statistics: { total_addresses: totalAddresses, total_qualified_addresses: qualifiedAddresses, total_reps: totalReps, percentage, }, } = action.payload.data;
        state.polygonPreview = {
            percentage,
            qualifiedAddresses,
            totalAddresses,
            totalReps,
        };
        state.isLoading = false;
    });
});
export default polygonPreview;
